import { RequestService } from '../../../../../common/services/RequestService';
import { UPDATE_REQUEST } from '../constants';

export const updateRequestRequest = payload => {
  return RequestService.put(
    UPDATE_REQUEST + `/${payload.id}`,
    JSON.stringify(payload.data)
  );
};
